import React from 'react';
import ReactMarkdown from 'react-markdown';
import changelog from '../../../../../CHANGELOG.md';
import headerPackageJSON from '../../../../../package.json';
import examplesPackageJSON from '../../../../package.json';
import {Button} from "@dts-soldel/dts-react-common";
import Pages from "../../app/pages/Pages";

const ChangeLog = () => {

	return (
		<div key="home">
			<h1 className="bg-primary color-white text-center"><span className="content">Utah.gov Header Changelog</span></h1>
			<div className="content">
				<div className="back-button"><Button label="back" onClick={Pages.public.home.forward}/></div>
				<h2>DTS Utah Header: <span className="color-primary">{`Version ${headerPackageJSON.version}`}</span></h2>
				<div className="mb-spacing bold-text">Examples Version: {examplesPackageJSON.version}</div>
				<p>
					Welcome to the DTS Utah Header examples website.
					Here you can see all the options for the header as well as create usable configuration JSON.
				</p>
				<p>
					Use the inputs on the left to try different configurations. The header will update as you
					change configuration. On the right you can see the JSON configuration file and can copy/paste
					that file in to your project.
				</p>
				<div className="markdown-content">
					<ReactMarkdown source={changelog}/>
				</div>
			</div>
		</div>
	);
};

export default ChangeLog;
